import { render, staticRenderFns } from "./AssignTestKit.vue?vue&type=template&id=3b71bf67&scoped=true"
import script from "./AssignTestKit.vue?vue&type=script&lang=js"
export * from "./AssignTestKit.vue?vue&type=script&lang=js"
import style0 from "./AssignTestKit.vue?vue&type=style&index=0&id=3b71bf67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b71bf67",
  null
  
)

export default component.exports